<template>
  <div class="wj_box">
    <div class="wj_header">
      <el-row>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 22, offset: 1 }"
          :md="{ span: 16, offset: 4 }"
          :lg="{ span: 14, offset: 5 }"
          :xl="{ span: 14, offset: 5 }"
          class="wj_header_main"
        >
          <div class="wj_header_left">
            <img
              alt="投票、企业投票云服务、企业投票、网络投票、微信投票、会议投票"
              src="../../../assets/images/logo2_1.png"
            />
          </div>
          <el-link
            class="wj_header_right_link"
            @click="userOut()"
            v-if="backTarget === 'signin'"
          >
            <i class="el-icon-switch-button"></i>
            <span>退出</span>
          </el-link>
          <el-link
            class="wj_header_right_link"
            @click="backList()"
            v-if="backTarget === 'list'"
          >
            <span>返回列表</span>
          </el-link>
        </el-col>
      </el-row>
    </div>
    <el-row class="wj_main">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 16, offset: 4 }"
        :lg="{ span: 14, offset: 5 }"
        :xl="{ span: 14, offset: 5 }"
      >
        <div class="main_box">
          <div class="main_body">
            <div class="form_bar">
              <div class="form_bar_search">
                <div class="condition_item"></div>
              </div>
              <div class="form_bar_btn">
                <el-button type="primary" size="mini" @click="refresh()" plain>
                  刷新
                </el-button>
              </div>
            </div>
            <div class="table-block" style="border-top: 0px">
              <div
                style="text-align: center; font-weight: 900; font-size: 32px"
              >
                {{ questionnaireResult.QuestionnaireName }}
              </div>
              <el-table
                ref="questionnaireResultTable"
                :data="questionnaireResult.AnswerPaperList"
                highlight-current-row
                style="width: 100%"
              >
                <el-table-column
                  type="index"
                  :index="indexMethod"
                  label="序号"
                  width="50"
                  v-if="!is_xs"
                >
                </el-table-column>
                <el-table-column
                  property="UserName"
                  label="用户"
                  min-width="200"
                >
                </el-table-column>
                <el-table-column label="是否交卷" width="100" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.IsSubmit" style="color: #67c23a">
                      <i class="el-icon-document-checked"></i>
                      已交卷
                    </span>
                    <span v-if="!scope.row.IsSubmit">
                      <i class="el-icon-document-delete"></i>
                      未交卷
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="交卷时间" width="130" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.SubmitDateTime">
                      {{
                        scope.row.SubmitDateTime
                          | dateformat('YYYY.MM.DD HH:mm')
                      }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="得分"
                  width="130"
                  align="center"
                  v-if="questionnaireResult.QuestionnaireType === 1"
                >
                  <template slot-scope="scope">
                    <span
                      v-if="
                        scope.row.AnswerTotalScore >=
                        questionnaireResult.PassScore
                      "
                      style="color: #ff6a00; font-size: 18px; font-weight: bold"
                    >
                      {{ scope.row.AnswerTotalScore }}
                    </span>
                    <span
                      v-if="
                        scope.row.AnswerTotalScore <
                        questionnaireResult.PassScore
                      "
                      style="color: red; font-size: 18px; font-weight: bold"
                    >
                      {{ scope.row.AnswerTotalScore }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="130" align="right">
                  <template slot-scope="scope">
                    <el-link
                      type="primary"
                      class="cell_link"
                      @click="openMarkingAnswerPaper(scope.row, scope.$index)"
                    >
                      阅卷
                    </el-link>
                    <el-link
                      type="primary"
                      class="cell_link"
                      @click="againQuestionnaire(scope.row)"
                      v-if="
                        scope.row.IsSubmit && questionnaireResult.State === 1
                      "
                      v-show="false"
                    >
                      重新答卷
                    </el-link>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                style="margin-top: 10px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[20, 100, 200, 500, 1000]"
                :page-size="resultQuery.MaxResultCount"
                :layout="pagination_layout"
                :total="questionnaireResultItemsCount"
                v-show="questionnaireResult.AnswerPaperList.length > 0"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="wj_footer">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 16, offset: 4 }"
        :lg="{ span: 14, offset: 5 }"
        :xl="{ span: 14, offset: 5 }"
      >
        <div>北京鹏宇成软件技术有限公司 提供技术支持</div>
      </el-col>
    </el-row>
    <MarkingAnswerPaper
      :fatherSubmitDialog="markingAnswerPaperDialog"
      ref="markingAnswerPaper"
    ></MarkingAnswerPaper>
  </div>
</template>

<script>
import questionnaireApi from '../../../api/wj/questionnaire'
import answerPaperApi from '../../../api/wj/answerPaper'
import MarkingAnswerPaper from '@/components/answerPaper/MarkingAnswerPaper.vue'
export default {
  components: {
    MarkingAnswerPaper
  },
  data () {
    return {
      resultQuery: {
        QuestionnaireId: null,
        SkipCount: 0,
        MaxResultCount: 100,
        Sorting: null
      },
      currentPage: 1,
      pagination_layout: 'prev, pager, next',
      questionnaireResultItemsCount: 0,
      questionnaireResult: {
        AnswerPaperList: []
      },
      backTarget: 'list'
    }
  },
  methods: {
    userOut: function () {
      this.$confirm('确定退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'wj_message_box'
      }).then(() => {
        this.$store.commit('REMOVE_ACCOUNT')
        if (this.$route.params.s === 'signin') {
          this.$router.push({ name: 'answerLogin', params: { cid: this.$route.params.cid, mid: this.$route.params.mid, qid: this.$route.params.qid } })
        } else if (this.$route.params.s === 'list') {
          this.$router.push({ name: 'answerLogin', params: { cid: this.$route.params.cid, mid: this.$route.params.mid, qid: 0 } })
        } else {
          this.$router.push({ name: 'answerLogin', params: { cid: this.$route.params.cid, mid: this.$route.params.mid, qid: 0 } })
        }
      }).catch(() => {

      })
    },
    backList: function () {
      this.$router.push({ name: 'answerQuestionnaireList', params: { mid: this.$route.params.mid } })
    },
    refresh: function () {
      this.getQuestionnaireResult()
    },
    getQuestionnaireResult: function () {
      const _this = this
      _this.openLoading()
      questionnaireApi.getQuestionnaireResult(_this.resultQuery).then(data => {
        _this.questionnaireResult = data
        _this.questionnaireResultItemsCount = data.TotalCount
        _this.$nextTick(function () {
          _this.$refs.questionnaireResultTable.doLayout()
        })
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    indexMethod (index) {
      return index + this.resultQuery.SkipCount + 1
    },
    handleSizeChange (val) {
      this.resultQuery.MaxResultCount = val
      this.getQuestionnaireResult()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.resultQuery.SkipCount = (val - 1) * this.resultQuery.MaxResultCount
      this.getQuestionnaireResult()
    },
    markingAnswerPaper: function (item) {
      const _this = this
      _this.openLoading()
      answerPaperApi.markingAnswerPaper({
        questionnaireId: item.Id
      }).then(data => {
        _this.$message({
          type: 'success',
          message: '打分成功！',
          customClass: 'custom_message'
        })
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    openMarkingAnswerPaper: function (row, index) {
      const _this = this
      _this.$refs.markingAnswerPaper.openMarkingAnswerPaper(this.questionnaireResult.QuestionnaireId, row.AnswerPaperId, row.UserId, index, row.IsSubmit)
    },
    markingAnswerPaperDialog: function (index, newTotalScore, isSubmit) {
      if (isSubmit) {
        if (newTotalScore !== -1) {
          if (newTotalScore) {
            this.questionnaireResult.AnswerPaperList[index].AnswerTotalScore = newTotalScore
          } else {
            this.questionnaireResult.AnswerPaperList[index].AnswerTotalScore = 0
          }
        }
      }
    }
  },
  created () {
    this.backTarget = this.$route.params.s
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
    this.resultQuery.QuestionnaireId = this.$route.params.qid
    this.getQuestionnaireResult()
  }
}
</script>

<style lang="less">
@import '../../../assets/css/wj.css';
</style>
